// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ce2e165b","171":"3257d7af","432":"28417e35","994":"14de6dcd"}[chunkId] + ".chunk.js";
};